import React from 'react';
import PropTypes from 'prop-types';

import Badge from "components/Badge";

import {greyishBlue700, orange700, red700} from "assets/jss/main";
import {UserAgentUtils} from "../../../../../../../../../utils/useragent";

PriorityBadge.propTypes = {
    score: PropTypes.number,
};

function PriorityBadge({score}) {
    const isHigh = score >= 8;
    const isMid = score >= 5;

    const isMobile = UserAgentUtils.isMobile();
    return (
        <Badge
            color={isHigh ? 'error' : isMid ? 'warning' : 'archived'}
            labelColor={isHigh ? red700 : isMid ? orange700 : greyishBlue700}
            border={true}
            rounded
            labelSize={isMobile ? 11 : 14}
            isBold={isMobile}
        >
            {score}/10
        </Badge>
    );
}

export default PriorityBadge;
